export default __webpack_public_path__ + "static/media/goshen89.39001a49.jpg";